import React, { Component } from 'react'
import { Button, Avatar, List, Tag } from 'antd'
import { injectIntl } from 'react-intl'

class Lottery extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: null
    }
  }

  onClick = (name, gameId, gameCode, gameIcon) => {
    this.setState({ selected: gameId })
    this.props.onGameSelected({
      type: 'lotto',
      name, gameId, gameCode, gameIcon
    })
  }

  renderBindGameButton = (selectedGameId, gameId, bindGameId, onGameConfirm, onGameCancel) => {
    if (selectedGameId !== gameId) return (null)
    if (selectedGameId == bindGameId) {
      return (
        <Button
          type="primary"
          danger
          onClick={() => onGameCancel()}>{this.props.intl.formatMessage({ id: 'games.cancelBind' })}</Button>
      )
    } else {
      return (
        <Button
          type="primary"
          onClick={() => onGameConfirm()}>{this.props.intl.formatMessage({ id: 'games.bind' })}</Button>
      )
    }
  }

  render() {
    const { intl, games, bindGameId, onGameConfirm, onGameCancel } = this.props

    return (
      <div
        id="scrollableDiv"
        style={{
          height: 300,
          width: '100%',
          overflow: 'auto',
          border: '1px solid rgba(140, 140, 140, 0.35)',
        }}
      >
        <List
          header={
            <div style={{ fontWeight: 'bold' }}>
              {intl.formatMessage({ id: 'games.menu' })}
            </div>
          }
          bordered
          itemLayout="horizontal"
          dataSource={games}
          renderItem={(game) => (
            <List.Item
              style={{ backgroundColor: 'white' }}
              className={`gamelist ${this.state.selected == game.gameId}`}
              onClick={() => this.onClick(game.name, game.gameId, game.gameCode, game.image)}
            >
              <List.Item.Meta
                avatar={<Avatar src={game.image} />}
                title={game.name}
                description={bindGameId == game.gameId ? <Tag color="#2db7f5">{intl.formatMessage({ id: 'games.binding' })}</Tag> : ""}
              />
              {this.renderBindGameButton(this.state.selected, game.gameId, bindGameId, onGameConfirm, onGameCancel)}
            </List.Item>
          )}
        />
      </div>

    )
  }
}

export default injectIntl(Lottery)